import Button from 'flarum/components/Button';

/**
 * The `UniLoginButton` component displays a Unilogin button which will redirect the user to UniLogin
 *
 * ### Props
 *
* - `path`
 */
export default class UniLoginButton extends Button {
  static initAttrs(attrs) {
    attrs.className = `${(attrs.className || '')} LogInButton`;

    attrs.onclick = function() {
      window.location.replace(app.forum.attribute('baseUrl') + attrs.path);
    };

    super.initAttrs(attrs);
  }
}
